import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useReducedMotionPreference } from "@/hooks/useReducedMotionPreference";
import "@/components/page-transition.css";

const SYMBOL = "/brand/gfc-simbolo.png";

export const PageTransition = () => {
  const { pathname } = useLocation();
  const reducedMotion = useReducedMotionPreference();
  const previousPath = useRef(pathname);
  const [activePath, setActivePath] = useState(null);

  useEffect(() => { const preload = new Image(); preload.src = SYMBOL; }, []);
  useEffect(() => {
    const from = previousPath.current;
    previousPath.current = pathname;
    if (from === pathname || reducedMotion || from.startsWith("/admin") || pathname.startsWith("/admin")) {
      setActivePath(null);
      return;
    }
    setActivePath(pathname);
    // Safety fallback only: normal cleanup follows the rendered animation end.
    const timeout = window.setTimeout(() => setActivePath(null), 2000);
    return () => window.clearTimeout(timeout);
  }, [pathname, reducedMotion]);

  if (!activePath || reducedMotion) return null;
  return <div key={activePath} data-testid="page-transition" data-destination={activePath} className="gfc-page-transition" aria-hidden="true"
    onAnimationEnd={(event) => {
      if (event.target === event.currentTarget && event.animationName === "gfc-page-reveal") setActivePath(null);
    }}>
    <img data-testid="page-transition-symbol" src={SYMBOL} alt="" width="320" height="320" className="gfc-page-transition-symbol" />
  </div>;
};